import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GenericConstants } from '../../enums/generic-constants.enum';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  constructor(private http: HttpClient) { }

  getApi(api:string){
    let url = environment.baseUrl + api;
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    return this.http.get(url, { headers: headers });
  }

  putApiCall(api:string, htmlContent:string){
    let url = environment.baseUrl + api;
    let requestBody = {
      html:htmlContent
    };
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    return this.http.put(url, JSON.stringify(requestBody), { headers: headers });
  }
}
